/**
 * Header Bar — Interaction-only JavaScript
 * All HTML is server-rendered by Liquid. This JS only handles:
 *   - Mobile menu toggle + slide panels
 *   - Mega menu hover (show/hide category panels)
 *   - Dropdown menu hover (open/close with timeout)
 *   - Search popup (open/close/escape)
 */
(function () {
  "use strict";

  // ── State ──
  var closeTimeout = null;

  // ── DOM Elements ──
  var mobileToggle = document.getElementById("vco-mobile-toggle");
  var mobileMenu = document.getElementById("vco-mobile-menu");
  var menuIcon = document.getElementById("vco-menu-icon");
  var closeIcon = document.getElementById("vco-close-icon");
  var megaMenu = document.getElementById("vco-mega-menu");

  // ── Helpers ──
  function clearCloseTimeout() {
    if (closeTimeout) {
      clearTimeout(closeTimeout);
      closeTimeout = null;
    }
  }

  function closeAllMenus() {
    megaMenu.classList.remove("open");
    document.querySelectorAll(".vco-dropdown-menu").forEach(function (el) {
      el.classList.remove("open");
    });
    document.querySelectorAll(".vco-nav-chevron").forEach(function (el) {
      el.classList.remove("rotated");
    });
  }

  // ═══════════════════════════════════
  // MOBILE MENU
  // ═══════════════════════════════════
  var mobileMenuOpen = false;

  mobileToggle.addEventListener("click", function () {
    mobileMenuOpen = !mobileMenuOpen;
    if (mobileMenuOpen) {
      mobileMenu.classList.add("open");
      menuIcon.style.display = "none";
      closeIcon.style.display = "block";
    } else {
      mobileMenu.classList.remove("open");
      menuIcon.style.display = "block";
      closeIcon.style.display = "none";
      slideToMain();
    }
  });

  // Slide to submenu panel
  document.querySelectorAll("[data-slide-to]").forEach(function (trigger) {
    var link = trigger.querySelector("a");
    trigger.addEventListener("click", function (e) {
      if (e.target === link || (link && link.contains(e.target))) return;
      e.preventDefault();
      e.stopPropagation();
      var menuKey = this.getAttribute("data-slide-to");
      var mainPanel = document.getElementById("vco-mobile-main-panel");
      var subPanel = document.getElementById("vco-mobile-panel-" + menuKey);
      if (mainPanel && subPanel) {
        mainPanel.classList.add("slide-out");
        subPanel.classList.add("active");
      }
    });
  });

  // Back buttons
  function slideToMain() {
    var mainPanel = document.getElementById("vco-mobile-main-panel");
    var activeSubPanel = document.querySelector(".vco-mobile-menu-panel.sub.active");
    if (mainPanel) mainPanel.classList.remove("slide-out");
    if (activeSubPanel) activeSubPanel.classList.remove("active");
  }

  document.querySelectorAll("[data-back-to]").forEach(function (backBtn) {
    backBtn.addEventListener("click", function (e) {
      e.preventDefault();
      slideToMain();
    });
  });

  // ═══════════════════════════════════
  // MEGA MENU (Produits) — Category hover
  // ═══════════════════════════════════
  var produitsItem = document.querySelector('[data-menu="produits"]');
  var btnProduits = document.getElementById("btn-produits");
  var categoryBtns = document.querySelectorAll(".vco-category-btn");
  var megaPanels = document.querySelectorAll(".vco-mega-panel");
  var promoPanels = document.querySelectorAll(".vco-promo-panel");

  // Switch category on hover
  categoryBtns.forEach(function (btn) {
    btn.addEventListener("mouseenter", function () {
      var catName = this.getAttribute("data-category");

      // Update active button
      categoryBtns.forEach(function (b) { b.classList.remove("active"); });
      this.classList.add("active");

      // Show matching content panel
      megaPanels.forEach(function (panel) {
        panel.style.display = panel.getAttribute("data-panel") === catName ? "" : "none";
      });

      // Show matching promo panel
      promoPanels.forEach(function (panel) {
        panel.style.display = panel.getAttribute("data-promo") === catName ? "" : "none";
      });
    });
  });

  // Open mega menu on hover
  if (produitsItem) {
    produitsItem.addEventListener("mouseenter", function () {
      clearCloseTimeout();
      closeAllMenus();
      megaMenu.classList.add("open");
      if (btnProduits) btnProduits.querySelector(".vco-nav-chevron").classList.add("rotated");
    });

    produitsItem.addEventListener("mouseleave", function () {
      closeTimeout = setTimeout(function () {
        megaMenu.classList.remove("open");
        if (btnProduits) btnProduits.querySelector(".vco-nav-chevron").classList.remove("rotated");
      }, 150);
    });
  }

  megaMenu.addEventListener("mouseenter", clearCloseTimeout);
  megaMenu.addEventListener("mouseleave", function () {
    closeTimeout = setTimeout(function () {
      megaMenu.classList.remove("open");
      if (btnProduits) btnProduits.querySelector(".vco-nav-chevron").classList.remove("rotated");
    }, 150);
  });

  // ═══════════════════════════════════
  // DROPDOWN MENUS (Thèmes, Bestseller, etc.)
  // ═══════════════════════════════════
  document.querySelectorAll(".vco-nav-item").forEach(function (navItem) {
    var menuKey = navItem.getAttribute("data-menu");
    if (menuKey === "produits") return; // Handled above

    var dropdown = document.getElementById("vco-dropdown-" + menuKey);
    var btn = document.getElementById("btn-" + menuKey);

    if (navItem && dropdown && btn) {
      navItem.addEventListener("mouseenter", function () {
        clearCloseTimeout();
        closeAllMenus();
        dropdown.classList.add("open");
        var chevron = btn.querySelector(".vco-nav-chevron");
        if (chevron) chevron.classList.add("rotated");
      });

      navItem.addEventListener("mouseleave", function () {
        closeTimeout = setTimeout(function () {
          dropdown.classList.remove("open");
          var chevron = btn.querySelector(".vco-nav-chevron");
          if (chevron) chevron.classList.remove("rotated");
        }, 150);
      });

      dropdown.addEventListener("mouseenter", clearCloseTimeout);
      dropdown.addEventListener("mouseleave", function () {
        closeTimeout = setTimeout(function () {
          dropdown.classList.remove("open");
          var chevron = btn.querySelector(".vco-nav-chevron");
          if (chevron) chevron.classList.remove("rotated");
        }, 150);
      });
    }
  });

  // ═══════════════════════════════════
  // SEARCH POPUP
  // ═══════════════════════════════════
  var searchPopup = document.getElementById("vco-search-popup");
  var searchPopupClose = document.getElementById("vco-search-popup-close");
  var searchPopupInput = document.getElementById("vco-search-popup-input");
  var searchInputs = document.querySelectorAll(".vco-search-input");

  function openSearchPopup() {
    if (searchPopup) {
      searchPopup.classList.add("open");
      document.body.style.overflow = "hidden";
      setTimeout(function () {
        if (searchPopupInput) searchPopupInput.focus();
      }, 100);
    }
  }

  function closeSearchPopup() {
    if (searchPopup) {
      searchPopup.classList.remove("open");
      document.body.style.overflow = "";
    }
  }

  searchInputs.forEach(function (input) {
    input.addEventListener("click", function (e) {
      e.preventDefault();
      openSearchPopup();
    });
    input.addEventListener("focus", function (e) {
      e.preventDefault();
      openSearchPopup();
    });
  });

  if (searchPopupClose) {
    searchPopupClose.addEventListener("click", function (e) {
      e.preventDefault();
      closeSearchPopup();
    });
  }

  if (searchPopup) {
    searchPopup.addEventListener("click", function (e) {
      if (e.target === searchPopup) closeSearchPopup();
    });
  }

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && searchPopup && searchPopup.classList.contains("open")) {
      closeSearchPopup();
    }
  });
})();
